import { Filters } from '@/types';

export namespace Materials {
  export enum Pages {
    MATERIALS = 'materials',
  }

  export interface Material {
    [key: string]: unknown,
    title: string,
    size: number,
    last_modified_at: string | null,
    is_directory: boolean,
    extension: string | null,
    path: string,
  }

  export interface Breadcrumb {
    [key: string]: unknown,
    title: string,
    path: string,
  }

  export interface MarketingMaterialUrl {
    id: number,
    path: string,
  }
}

export interface MaterialsFilters extends Filters {
  path: string,
}

export enum TypeMaterial {
  FILE = 'file',
  FOLDER = 'folder'
}
